if (!customElements.get('content-truncator')) {

  class ContentTruncator extends HTMLElement {
    constructor() {
      super();
      window.initScriptOnDemand(this, this.init.bind(this));
    }

    init() {
      this.contentWrapper = this.querySelector('.content-truncator__wrapper');
      this.content = this.querySelector('.content-truncator__content');
      this.button = this.querySelector('.content-truncator__button');
      
      if (!this.contentWrapper || !this.button) return;
      
      this.originalMaxHeight = this.contentWrapper.style.maxHeight;
      this.isExpanded = false;
      
      // Store the original button text
      this.showMoreText = this.button.textContent.trim();
      // Get show less text from data attribute or use default
      this.showLessText = this.button.dataset.showLessText || 'Show less';
      
      this.button.addEventListener('click', this.toggleContent.bind(this));
      
      // Check if content needs truncation
      this.checkTruncation();
    }

    checkTruncation() {
      if (!this.contentWrapper) return;
      
      // Temporarily remove max-height to check natural height
      const originalMaxHeight = this.contentWrapper.style.maxHeight;
      this.contentWrapper.style.maxHeight = 'none';
      const naturalHeight = this.contentWrapper.scrollHeight;
      this.contentWrapper.style.maxHeight = originalMaxHeight;
      
      const maxHeight = parseInt(originalMaxHeight);
      
      if (naturalHeight > maxHeight) {
        this.contentWrapper.classList.add('is-expandable');
        this.button.style.display = 'block';
      } else {
        this.contentWrapper.classList.remove('is-expandable');
        this.button.style.display = 'none';
      }
    }

    toggleContent() {
      if (!this.contentWrapper) return;
      
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.contentWrapper.style.maxHeight = 'none';
        this.contentWrapper.classList.add('expanded');
        this.button.textContent = this.showLessText;
        this.button.setAttribute('data-action', 'collapse');
      } else {
        this.contentWrapper.style.maxHeight = this.originalMaxHeight;
        this.contentWrapper.classList.remove('expanded');
        this.button.textContent = this.showMoreText;
        this.button.setAttribute('data-action', 'expand');
      }
    }
  }

  customElements.define('content-truncator', ContentTruncator);
}